module.exports = __webpack_public_path__ + "img/violet-3.25c751aa.png";